module.exports = __webpack_public_path__ + "img/sankaku_82_blue.c8ddf98a.png";